import http from '../../../../Services/common/http-common'
import IPedidosCasaCuervo from '../Interfaces/I325Pedidos'
import DTO325AduanasPedidos from '../../../../DTO/Clientes/CasaCuervo/DTO325AduanasPedidos'
import DTO325UpdateFromWeb from '../../../../DTO/Clientes/CasaCuervo/DTO325UpdateFromWeb'
import { IServerSideTransactionManager } from 'ag-grid-community'
import I325RptCOVEs from '../Interfaces/I325RptCOVEs'
import I325CatBitacoraViaje from '../Interfaces/I325CatBitacoraViaje'
import I325BitacoraViaje from '../Interfaces/I325BitacoraViaje'

class CasaCuervoDataService {
  getAll(Inicio: string, Fin: string, Aduana: string) {
    return http.get<IPedidosCasaCuervo[]>(
      `/Clientes/CasaCuervo/Pedidos/getAll?Inicio=${Inicio}&Fin=${Fin}&Aduana=${Aduana}`
    )
  }
  GetById(Id: number) {
    return http.get<IPedidosCasaCuervo>(
      `/Clientes/CasaCuervo/Pedidos/GetById?Id=${Id}`
    )
  }
  getAduanas(Usuario: number, TipoUsuario: number) {
    return http.get<DTO325AduanasPedidos[]>(
      `/Clientes/CasaCuervo/Pedidos/getAduanas?Usuario=${Usuario}&TipoUsuario=${TipoUsuario}`
    )
  }
  Update(id: number, Campo: string, Valor: string) {
    return http.put<IPedidosCasaCuervo[]>(
      `/Clientes/CasaCuervo/Pedidos/Update/${id}/${Campo}/${Valor}`
    )
  }
  UpdateInfo(data: DTO325UpdateFromWeb) {
    return http.put<IPedidosCasaCuervo>(
      `/Clientes/CasaCuervo/Pedidos/UpdateInfo/${data.id}`,
      data
    )
  }
  Append(id: number, Proceso: number) {
    return http.get<IPedidosCasaCuervo[]>(
      `/Clientes/CasaCuervo/Pedidos/UploadExcel?id=${id}&Proceso=${Proceso}`
    )
  }
  GeneratePDF4CC(id: number) {
    return http
      .get<ArrayBuffer>(
        `/Clientes/CasaCuervo/Pedidos/GeneratePDF4CC?id=${id}`,
        { responseType: 'arraybuffer' }
      )
      .then(function (response) {
        return response
      })
      .catch(function (error) {
        console.log(error)
      })
  }
  GenerateTempPDF(
    NoPedido: string,
    NoCaja: string,
    nMedidaCaja: string,
    Factura: string,
    Sello1: string,
    Sello2: string,
    Carrier: string
  ) {
    return http
      .get<ArrayBuffer>(
        `/Clientes/CasaCuervo/Pedidos/GenerateTempPDF?NoPedido=${NoPedido}&NoCaja=${NoCaja}&nMedidaCaja=${nMedidaCaja}&Factura=${Factura}&Sello1=${Sello1}&Sello2=${Sello2}&Carrier=${Carrier}`,
        { responseType: 'arraybuffer' }
      )
      .then(function (response) {
        return response
      })
      .catch(function (error) {
        console.log(error)
      })
  }
  GetRptCOVEs(Inicio: string, Fin: string) {
    return http.get<I325RptCOVEs[]>(
      `/Clientes/CasaCuervo/Pedidos/GetRptCOVEs?Inicio=${Inicio}&Fin=${Fin}`
    )
  }
  UpdateLoadDate(Id: number, LoadDate: string) {
    return http.put<boolean>(
      `/Clientes/CasaCuervo/Pedidos/UpdateLoadDate/${Id}/${LoadDate}`
    )
  }
  Delete(Id: number) {
    return http.delete<boolean>(
      `/Clientes/CasaCuervo/Pedidos/Delete/${Id}`
    )
  }
    GetCatBitacoraViaje() {
    return http.get<I325CatBitacoraViaje[]>(
      `/Clientes/CasaCuervo/Pedidos/GetCatBitacoraViaje`
    )
  }
   AppendCatBitacoraViaje(data: I325CatBitacoraViaje) {
    return http.post<Boolean>(
      `/Clientes/CasaCuervo/Pedidos/AppendCatBitacoraViaje`, data)
  }
  AppendBitacoraViaje(data: I325BitacoraViaje) {
    return http.post<Boolean>(
      `/Clientes/CasaCuervo/Pedidos/AppendBitacoraViaje`, data)
  }
    GetBitacoraViaje(IdPedido: number) {
    return http.get<I325BitacoraViaje[]>(
      `/Clientes/CasaCuervo/Pedidos/GetBitacoraViaje?IdPedido=${IdPedido}`
    )
  }
  DeleteBitacora(Id: number) {
    return http.delete<boolean>(
      `/Clientes/CasaCuervo/Pedidos/Delete/Bitacora/${Id}`
    )
  }
    FechaLiberacionUpdate(Id: number, FechaLiberacion: string) {
    return http.put<boolean>(
      `/Clientes/CasaCuervo/Pedidos/FechaLiberacion/Update/${Id}/${FechaLiberacion}`
    )
  }
}
export default new CasaCuervoDataService()
